import React from 'react';

function ToastError(props) {
  if (!props.isOpen) {
    return null;
  }

  return (
    <div className="fixed top-28 right-4 z-50">
      <div className="flex w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-md">
        <div className="flex items-center justify-center w-12 bg-red-500">
          <i className='bx bx-x text-red-500 bg-white w-6 h-6 rounded-full text-xl flex items-center justify-center'></i>
        </div>

        <div className="px-4 py-2 -mx-3">
          <div className="mx-3">
            <span className="font-semibold text-red-500">{props.title}</span>
            <p className="text-sm text-gray-600">{props.text}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ToastError;